module.exports = __webpack_public_path__ + "media/customizations/regencyatauburnstation/logo-new-d3b66e23cdeaf6ebd91ecfb03356fdda.png";